module.exports = __webpack_public_path__ + "static/adjustable-base-2-intro-4af055f3bd4b1fd1b28ccc2c0a8912a4.mp4";